import { Stack, StackProps } from "@chakra-ui/react"
import React from "react"

interface PageContentProps extends StackProps {}

export function PageContent(props: PageContentProps) {
    return <Stack pt={6} pb={6} align="stretch" direction={"column"} spacing={6} {...props}></Stack>
}
